import React from "react";
import { House, LayoutGrid, Package, ShoppingCart } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Barra de navegação inferior (só celular/tablet).
 * Mostra apenas as telas liberadas no menu do usuário; "Menu" abre a gaveta
 * com todas as telas.
 */
const NavItem = ({ link, label, icon: Icon, badge, activeTab, onSelect }) => {
  const active = activeTab === link;
  return (
    <button
      type="button"
      onClick={() => onSelect(link)}
      aria-current={active ? "page" : undefined}
      className={cn(
        "flex h-12 min-w-[64px] flex-col items-center justify-center transition-colors",
        active ? "font-bold text-primary" : "text-muted-foreground hover:text-foreground",
      )}
    >
      <span className="relative flex items-center justify-center">
        <Icon className="h-5 w-5" />
        {badge > 0 && (
          <span className="absolute -right-3 -top-1.5 min-w-[18px] rounded-full bg-primary px-1 text-center text-[10px] font-bold leading-[16px] text-primary-foreground">
            {badge > 99 ? "99+" : badge}
          </span>
        )}
      </span>
      <span className="mt-0.5 text-[11px] font-semibold">{label}</span>
    </button>
  );
};


const BottomNav = ({ canAccess, activeTab, onSelect, onOpenMenu, pendingCount = 0 }) => {
  const homeActive = activeTab === "dashboard";

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-30 border-t bg-card/95 pb-safe shadow-[0_-2px_12px_rgba(31,46,30,0.04)] backdrop-blur-xl lg:hidden"
      aria-label="Navegação principal"
    >
      <div className="mx-auto flex h-16 max-w-lg items-center justify-around px-2">
        {canAccess("orders") && (
          <NavItem
            link="orders"
            label="Pedidos"
            icon={ShoppingCart}
            badge={pendingCount}
            activeTab={activeTab}
            onSelect={onSelect}
          />
        )}
        {canAccess("products") && (
          <NavItem
            link="products"
            label="Produtos"
            icon={Package}
            activeTab={activeTab}
            onSelect={onSelect}
          />
        )}
        {canAccess("dashboard") && (
          <button
            type="button"
            onClick={() => onSelect("dashboard")}
            aria-current={homeActive ? "page" : undefined}
            className="-mt-5 flex flex-col items-center justify-center"
          >
            <span
              className={cn(
                "flex h-[52px] w-[52px] items-center justify-center rounded-full shadow-[0_4px_14px_rgba(27,94,32,0.35)] transition-transform active:scale-95",
                homeActive
                  ? "bg-primary text-primary-foreground"
                  : "bg-card text-primary ring-1 ring-border",
              )}
            >
              <House className="h-6 w-6" />
            </span>
            <span className="mt-1 text-[11px] font-semibold text-primary">Início</span>
          </button>
        )}
        <button
          type="button"
          onClick={onOpenMenu}
          className="flex h-12 min-w-[64px] flex-col items-center justify-center text-muted-foreground transition-colors hover:text-foreground"
        >
          <LayoutGrid className="h-5 w-5" />
          <span className="mt-0.5 text-[11px] font-semibold">Menu</span>
        </button>
      </div>
    </nav>
  );
};

export default BottomNav;
